module.exports = __webpack_public_path__ + "img/time-badge-silver.35462915.svg";